// extracted by mini-css-extract-plugin
export default {"card":"categories_card__V51Zp","cardTitle":"categories_cardTitle__NIjRH"};